<!-- eslint-disable vue/no-mutating-props -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="绑定租赁订单"
    :width="'824px'"
    :append-to-body="true"
    :destory-on-close="true"
    :before-close="cancelHandle"
    @open="handleInitial"
  >
    <div class="bindOrder_tips">
      <div>
        <span>提示:</span
        >提交个人和指定维保方案绑定关系后，可以前往"车辆-维保管理-租赁订单绑定纪录"中查看
      </div>
      <div><span>租赁方案所属公司:</span>{{ userInfo.tenantName }}</div>
      <div><span>维保项目:</span>{{ planRow.itemName }}</div>
      <div><span>维修厂:</span>{{ planRow.usableStoreNameList }}</div>
    </div>
    <!-- form表单 -->
    <el-form
      :model="formData"
      width="80%"
      label-width="100px"
      label-position="right"
    >
      <el-form-item
        v-for="(item, index) in rentOrderFormColumns"
        :key="index"
        :label="item.label"
        class="selectPlan-container"
      >
        <div class="selectPlan-box">
          <QS-select
            remote
            :remote-method="item.remoteMethod"
            v-model="formData[item.modelType]"
            multiple
            placeholder="请选择"
            filterable
            class="selectPlan"
            clearable
            :optionData="selectData[item.modelType]"
            :optionConfig="{labelKey: 'name', valueKey: 'id'}"
            @clear="() => handleClear(item)"
          >
          </QS-select>
        </div>
        <el-button
          v-if="index === 0 || index === 1"
          type="primary"
          @click="handlebatchAdd(item.modelType)"
          >批量添加</el-button
        >
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 确认绑定信息 -->
    <QS-h4-title title="确认绑定信息" />
    <el-table
      width="80%"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleTableSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        width="110"
        :prop="item.prop"
        :label="item.name"
        v-for="item in rentOrderTableColumns"
        :key="item.orderId"
      >
      </el-table-column>
      <el-table-column prop="accountId" label="选择付款账户" width="220">
        <template slot-scope="scope">
          <el-form
            :model="scope.row"
            label=""
            :ref="`form${scope.row.orderId}`"
          >
            <el-form-item
              prop="accountId"
              :rules="[
                {
                  required: true,
                  message: '请选择付款账户',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="scope.row.accountId"
                clearable
                filterable
                placeholder="请选择"
                class="resetopions"
                @change="
                  (accountId) => handleAccountChange(accountId, scope.row)
                "
              >
                <el-option
                  v-for="item in subAccountOptions"
                  :key="item.accountId"
                  :label="item.merchantName"
                  :value="item.accountId"
                >
                  <div class="selectPlan-item">
                    <TextOverTooltip
                      :content="item.merchantName"
                      placement="top"
                    />
                    <TextOverTooltip
                      :content="item.bankCardNo"
                      placement="top"
                    />
                    <TextOverTooltip
                      :content="item.bankShortName"
                      placement="top"
                    />
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
    </el-table>

    <!-- 批量添加 -->
    <el-dialog
      :visible.sync="batchAddVisible"
      title="批量添加"
      :width="'824px'"
      :before-close="handleCloseBatchAddDiaolog"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="batch_tips">
        输入枚举值,每行一个“ : ”请使用对应的ID每行一个:
      </div>
      <el-input
        type="textarea"
        :rows="5"
        :autosize="{ minRows: 5, maxRows: 200 }"
        placeholder="请输入内容"
        v-model="batchTextarea"
        @input="handleTextAreaInput"
      >
      </el-input>

      <div slot="footer">
        <div class="mt16" style="text-align: center">
          <el-button size="small" @click="handleBatchDialogCancel"
            >取消</el-button
          >
          <el-button type="primary" size="small" @click="handleBatchDialogOk"
            >提交</el-button
          >
        </div>
      </div>
    </el-dialog>
    <div slot="footer">
      <div class="mt16" style="text-align: center">
        <el-button size="small" @click="cancelHandle">取消</el-button>
        <el-button type="primary" size="small" :loading="loading" @click="handleOK"
          >提交</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  getCarNamesApi,
  getCarLicenseManageApi,
  getRanOrderApi,
  searchRantOrderListApi,
  searchCarListByIdsApi,
} from '../services'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { createOrderLinkApi } from '../../services'
import config from './config'
import { getSubAccountList } from '@/api/domain/finance'
import { validateIsNumber } from '@/utils/validate'

export default {
  name: 'bindOrderDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    planRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const { rentOrderFormColumns, rentOrderTableColumns } = config.call(this)
    return {
      subAccountOptions: [],
      idAndHandelWays: [],
      batchTextarea: '',
      batchAddType: '',
      rentOrderTableColumns,
      rentOrderFormColumns,
      batchAddVisible: false,
      isAbnormal: false,
      abnormalData: [],
      formData: {
        driverIds: [],
        carIds: [],
        platNos: [],
        ids: [],
      },
      loading: false,
      tableData: [],
      selectData: {
        driverIds: [],
        carIds: [],
        platNos: [],
        ids: [],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    getSubAccountList() {
      getSubAccountList({
        accountType: 2,
        channelType: 6,
        openState: 3,
        state: 1,
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        const { code, data } = res
        if (code !== 1) return
        this.subAccountOptions = data?.items || []
      })
    },
    handleInitial() {
      this.getCustomerNames()
      this.getSubAccountList()
      this.getCarNames()
      this.getCarLicenseManage()
      this.getRanOrder()
      this.isAbnormal = false
      this.abnormalData = []
    },
    handleAccountChange(accountId, row) {
      this.idAndHandelWays.find((item) => {
        if (item.id === row.orderId) {
          item.accountId = accountId
          return true
        }
        return false
      })
    },
    handleTableSelectionChange(rows) {
      this.idAndHandelWays = rows.map((item) => ({
        id: item.orderId,
        accountId: item.accountId,
      }))
    },
    handleOK() {
      if (this.idAndHandelWays?.length === 0) {
        this.$message.error('最少选择1条租赁订单')
        return
      }
      let _status = true
      this.tableData.forEach((item) => {
        const ref = `form${item.orderId}`
        this.$refs[ref].clearValidate()
      })
      this.idAndHandelWays.forEach((item) => {
        const ref = `form${item.id}`
        this.$refs[ref].validate((valid) => {
          if (!valid) {
            _status = false
          }
        })
      })
      if (!_status) return
      this.createOrderLink({
        idAndHandelWays: this.idAndHandelWays,
        itemId: this.planRow.id,
      })
    },
    cancelHandle(isAbnormal, abnormalData) {
      this.$emit('close', isAbnormal, abnormalData)
      this.idAndHandelWays = []
      this.tableData = []
      this.selectData = {
        driverIds: [],
        carIds: [],
        platNos: [],
        ids: [],
      }
      this.formData = {
        driverIds: [],
        carIds: [],
        platNos: [],
        ids: [],
      }
    },
    // 批量添加
    handlebatchAdd(type) {
      this.batchAddType = type
      this.batchAddVisible = true
    },
    handleCloseBatchAddDiaolog() {
      this.batchTextarea = ''
      this.batchAddType = ''
      this.batchAddVisible = false
    },
    handleBatchDialogCancel() {
      this.batchTextarea = ''
      this.batchAddType = ''
      this.batchAddVisible = false
    },
    handleTextAreaInput() {
      this.batchTextarea = this.batchTextarea.replace(/[^0-9:\n\r]/g, '')
    },
    handleBatchDialogOk() {
      const len = this.batchTextarea.length
      if (this.batchTextarea[len - 1] === ':') {
        this.batchTextarea = this.batchTextarea.slice(0, len - 1)
      }
      const list = this.batchTextarea.split(':').map((item) => {
        return Number(item.replaceAll('\n', ''))
      })

      let listType = 0
      if (this.batchAddType === 'driverIds') {
        listType = 0
      } else if (this.batchAddType === 'carIds') {
        listType = 1
      }
      this.searchCarListByIds(listType, list)
    },
    // 搜索
    handleSearch() {
      if (this.formData.driverIds.length > 200) {
        this.$message.error('司机名称项:最多只能选择200条')
        return
      } else if (this.formData.carIds.length > 200) {
        this.$message.error('车辆名称项:最多只能选择200条')
        return
      } else if (this.formData.platNos.length > 200) {
        this.$message.error('车牌号项:最多只能选择200条')
        return
      } else if (this.formData.ids.length > 200) {
        this.$message.error('租赁订单项:最多只能选择200条')
        return
      } else if (
        this.formData.driverIds.length === 0 &&
        this.formData.carIds.length === 0 &&
        this.formData.platNos.length === 0 &&
        this.formData.ids.length === 0
      ) {
        this.$message.error('至少选择一项')
        return
      }
      // 调用接口
      this.searchRantOrderList(this.formData)
    },
    // eslint-disable-next-line vue/no-unused-properties
    async getCustomerNames(name = '') {
      const [err, _data] = await this.$to(
        searchByCustomerNameSensitive({
          customerName: name?.trim() || '',
          mixedType: 'YES',
        }),
      )
      if (!err) {
        const { code, data = [] } = _data
        if (code === 1) {
          // 司机名称
          this.selectData.driverIds = data.map((item) => ({
            id: item.id,
            name: `${item.customerName} ${item.customerTel || ''}`,
          }))
        }
      }
    },
    async getCarNames(name) {
      const [err, _data] = await this.$to(getCarNamesApi({ name }))
      if (!err) {
        let { data } = _data
        const { code } = _data
        if (code === 1) {
          // 车辆名称
          if (!Array.isArray(data)) data = []
          this.selectData.carIds = data
        }
      }
    },
    async getCarLicenseManage(name) {
      const [err, _data] = await this.$to(getCarLicenseManageApi({ name }))
      if (!err) {
        let { data } = _data
        const { code } = _data
        if (code === 1) {
          // 车牌号
          if (!Array.isArray(data)) data = []
          this.selectData.platNos = data
        }
      }
    },
    async getRanOrder(id) {
      if (!id) return
      if (!validateIsNumber(id)) {
        this.$message.error('请输入正确的租赁订单(ID)')
        this.formData.ids = []
        return
      }
      const [err, _data] = await this.$to(getRanOrderApi({ id }))
      if (!err) {
        let { data } = _data
        const { code } = _data
        if (code === 1) {
          // 租赁订单
          if (!Array.isArray(data)) data = []

          const idsData = data.map((item) => {
            return { id: item.id, name: item.id }
          })
          this.selectData.ids = idsData
        }
      }
    },
    // 批量添加司机名称|车辆名称
    async searchCarListByIds(type, ids) {
      const [err, _data] = await this.$to(
        searchCarListByIdsApi({ listType: type, ids }),
      )
      if (!err) {
        let { data } = _data
        const { code } = _data
        if (code === 1) {
          if (!Array.isArray(data)) data = []
          if (type === 0) {
            this.formData.driverIds = Array.from(
              new Set([
                ...this.formData.driverIds,
                ...data.map((item) => item.id),
              ]),
            )
            this.selectData.driverIds = data
          } else {
            this.formData.carIds = Array.from(
              new Set([...this.formData.carIds, ...data.map((item) => item.id)]),
            )
            this.selectData.carIds = data
          }
          this.handleCloseBatchAddDiaolog()
        }
      }
    },
    // 搜索订单信息
    async searchRantOrderList(params) {
      const [err, _data] = await this.$to(searchRantOrderListApi({ ...params }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (Array.isArray(data) && data.length === 0) {
            this.$message.error('暂无数据')
          }
          // 搜索结果
          this.tableData = data || []
          this.$nextTick(() => {
            this.tableData.forEach((row) => {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            })
          })
        }
      }
    },
    // 创建用户绑定记录
    async createOrderLink(params) {
      if (this.loading) return
      this.loading = true
      const [err, _data] = await this.$to(createOrderLinkApi({ ...params }))
      if (!err) {
        const { code, data } = _data
        if (code === 1) {
          if (Array.isArray(data) && data.length > 0) {
            this.isAbnormal = true
            this.abnormalData = data
            this.cancelHandle(this.isAbnormal, this.abnormalData)
          } else {
            this.isAbnormal = false
            this.cancelHandle(this.isAbnormal)
            this.$message.success('绑定成功')
          }
        }
      }
      // 为了让二次弹窗成功
      this.loading = false
    },
    // select清空时重新远程搜索获取列表
    handleClear(item) {
      item.remoteMethod()
    },
  },
}
</script>

<style lang="scss" scoped>
.bindOrder_tips {
  margin-bottom: 20px;
  font-size: 14px;
  & > div {
    margin-bottom: 10px;
    & > span {
      font-weight: 500;
      margin-right: 5px;
    }
  }
}
::v-deep(.el-select-dropdown) {
  width: 189px !important;
}

.selectPlan-container ::v-deep .el-form-item__content {
  display: flex;
  align-items: center;
}

.selectPlan-box {
  width: 60%;
  max-height: 155px;
  overflow-y: auto;
  margin-right: 10px;
  .selectPlan {
    width: 100%;
  }
}

.batch_tips {
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}
::v-deep(.el-form-item--small.el-form-item) {
  margin-top: 24px;
}

::v-deep(.el-clamp-lines__alone) {
  overflow: visible;
  display: inline-block;
}

.selectPlan-item {
  height: auto;
  width: 150px !important;
}
.resetopions {
  height: auto;
}
.el-select-dropdown__item {
  height: auto;
}
</style>
